// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableBody__JxQKT {
  font-size: 14px;
  line-height: 14px;
}
@media (max-width: 1080px) {
  .tableBody__JxQKT {
    font-size: 12px;
  }
}

.tableBodyRowWrapper__cI7i_ {
  display: flex;
  align-items: center;
  width: 100%;
  scroll-margin-top: 105px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
  padding: 0 25px 0 35px;
  font-style: normal;
  font-weight: 400;
}
@media (max-width: 1080px) {
  .tableBodyRowWrapper__cI7i_ {
    padding: 0;
  }
}
.tableBodyRowWrapper__cI7i_:hover {
  background: var(--tables-primary-row-surface-hover);
}

.onboardingTable__tdYYq {
  max-height: 370px;
  height: 100%;
  overflow: hidden;
  margin-bottom: 5px;
}

.tableBodyRowCategory__jG27Y {
  width: 100%;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  display: flex;
  height: 45px;
  padding: 0px 15px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  cursor: pointer;
}

.expandArrow__YKhQI {
  transform: rotate(-90deg);
}

.tableBodyRowRecentlyViewed__BPvZ5 {
  background: var(--tables-primary-row-surface-hover);
}

.tableBodyRowType__hrkwN {
  max-width: 410px;
  width: 100%;
}
@media (max-width: 1536px) {
  .tableBodyRowType__hrkwN {
    max-width: 265px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowType__hrkwN {
    max-width: 170px;
  }
}
@media (max-width: 1080px) {
  .tableBodyRowType__hrkwN {
    max-width: 130px;
  }
}

.tableBodyRowTypeWithoutWo__HFTTv {
  max-width: 425px;
}
@media (max-width: 1536px) {
  .tableBodyRowTypeWithoutWo__HFTTv {
    max-width: 345px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowTypeWithoutWo__HFTTv {
    max-width: 240px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowTypeWithoutWo__HFTTv {
    max-width: 100px;
  }
}

.tableBodyRowWo__Xy4I8 {
  max-width: 115px;
  width: 100%;
  margin-right: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 1280px) {
  .tableBodyRowWo__Xy4I8 {
    max-width: 105px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowWo__Xy4I8 {
    display: none;
  }
}

.tableBodyRowEquipment__SDPTo {
  max-width: 410px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 1536px) {
  .tableBodyRowEquipment__SDPTo {
    max-width: 265px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowEquipment__SDPTo {
    max-width: 170px;
  }
}
@media (max-width: 1080px) {
  .tableBodyRowEquipment__SDPTo {
    max-width: 130px;
  }
}

.tableBodyRowEquipmentWithoutWo__QTq6x {
  max-width: 425px;
}
@media (max-width: 1536px) {
  .tableBodyRowEquipmentWithoutWo__QTq6x {
    max-width: 345px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowEquipmentWithoutWo__QTq6x {
    max-width: 240px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowEquipmentWithoutWo__QTq6x {
    max-width: 100px;
  }
}
@media (max-width: 1536px) {
  .tableBodyRowEquipmentWithoutWo__QTq6x .tableBodyRowEquipmentSmall__LkaPs {
    max-width: 285px;
  }
}
@media (max-width: 1440px) {
  .tableBodyRowEquipmentWithoutWo__QTq6x .tableBodyRowEquipmentSmall__LkaPs {
    max-width: 240px;
  }
}

@media (max-width: 1536px) {
  .tableBodyRowEquipmentSmall__LkaPs {
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
}
@media (max-width: 1140px) {
  .tableBodyRowEquipmentSmall__LkaPs {
    max-width: 150px;
  }
}
.tableBodyRowComponent__lf6zb {
  max-width: 250px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 1536px) {
  .tableBodyRowComponent__lf6zb {
    max-width: 200px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowComponent__lf6zb {
    max-width: 150px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowComponent__lf6zb {
    display: none;
  }
}

.tableBodyRowComponentWithoutWo__WyCT8 {
  max-width: 265px;
}
@media (max-width: 1536px) {
  .tableBodyRowComponentWithoutWo__WyCT8 {
    max-width: 215px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowComponentWithoutWo__WyCT8 {
    max-width: 165px;
  }
}

.tableBodyRowUpdate__mHivR {
  max-width: 450px;
  width: 100%;
  text-align: end;
}
@media (max-width: 1440px) {
  .tableBodyRowUpdate__mHivR {
    max-width: 280px;
  }
}
@media (max-width: 1080px) {
  .tableBodyRowUpdate__mHivR {
    max-width: 125px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowUpdate__mHivR {
    max-width: unset;
    width: 180px;
  }
}

.tableBodyRowEmpty__MqL5N {
  width: 100%;
}

.tableBodyRowCategory__jG27Y {
  width: 100%;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  display: flex;
  height: 45px;
  padding: 0px 15px;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  cursor: pointer;
}

.tableBodyRow__hFlrx {
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 5px;
  width: 100%;
  color: var(--tables-primary-row-text-main);
  gap: 10px;
}
@media (min-width: 1921px) {
  .tableBodyRow__hFlrx {
    justify-content: space-between;
  }
}
@media (max-width: 850px) {
  .tableBodyRow__hFlrx {
    margin-left: 0;
  }
}

.aiTableTooltip__zNeUt {
  max-width: 300px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}

.urgencyStandard__DtClR {
  border-left: 3px solid var(--legend-for-header-standard);
}

.urgencyHigh__qsf7O {
  border-left: 3px solid var(--legend-for-header-high);
}

.urgencyCritical__OZa97 {
  border-left: 3px solid var(--legend-for-header-critical);
}

.tableBodyRowLocation__nm2Ax {
  max-width: 250px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 1536px) {
  .tableBodyRowLocation__nm2Ax {
    max-width: 150px;
    margin-right: 7px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowLocation__nm2Ax {
    max-width: 135px;
  }
}
@media (max-width: 1080px) {
  .tableBodyRowLocation__nm2Ax {
    max-width: 70px;
    margin-right: 0;
  }
}

.tableBodyRowLocationWithoutWo__tzWlE {
  max-width: 275px;
}
@media (max-width: 1536px) {
  .tableBodyRowLocationWithoutWo__tzWlE {
    max-width: 160px;
  }
}
@media (max-width: 1280px) {
  .tableBodyRowLocationWithoutWo__tzWlE {
    padding-right: 15px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowLocationWithoutWo__tzWlE {
    max-width: 95px;
  }
}

.tableBodyRowLocationName__es2i4 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 1080px) {
  .tableBodyRowLocationName__es2i4 {
    overflow: hidden;
  }
}

.tableRowAdditionalInfo__FYtza {
  display: block;
  max-width: 130px;
  color: var(--tables-primary-row-text-additional);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-top: 2px;
}
@media (max-width: 1080px) {
  .tableRowAdditionalInfo__FYtza {
    font-size: 12px;
  }
}

.tableBodyRowTime__TO2rW {
  max-width: 130px;
  width: 100%;
  text-align: end;
}
@media (max-width: 1280px) {
  .tableBodyRowTime__TO2rW {
    max-width: 140px;
  }
}
@media (max-width: 850px) {
  .tableBodyRowTime__TO2rW {
    max-width: 115px;
    text-align: end;
  }
}

.tableRowUpdatedInfo__rwq8E {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-bottom: 2px;
}
@media (max-width: 1080px) {
  .tableRowUpdatedInfo__rwq8E {
    font-size: 12px;
  }
}

.tableBodyRowSkeleton__E0IKv {
  padding: 16.5px 0;
  gap: 25px;
}
.tableBodyRowSkeleton__E0IKv > div {
  height: 24px;
}

.skeletonTextClassName__DYNYP {
  height: 24px;
}

.skeletonTableBodyRowWrapper__qReyJ {
  cursor: default;
}
.skeletonTableBodyRowWrapper__qReyJ:hover {
  background: initial;
}

.tableBodyRowBold__ycWar {
  font-weight: bolder;
}

.tableCellsHide__JqBEo {
  display: none;
}
@media (max-width: 850px) {
  .tableCellsHide__JqBEo {
    display: block;
    max-width: 126px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 2;
  }
}

.tableCellTitle__d1H_i {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  max-width: unset;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItems/components/ActionItemsTableBody/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;AAzEF;AA2EE;EAJF;IAKI,eAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,yDAAA;EACA,yDAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAxEF;AA0EE;EAXF;IAYI,UAAA;EAvEF;AACF;AAyEE;EACE,mDAAA;AAvEJ;;AA2EA;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,yDAAA;EACA,qDAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,yBAAA;AAxEF;;AA2EA;EACE,mDAAA;AAxEF;;AA2EA;EACE,gBAAA;EACA,WAAA;AAxEF;AA0EE;EAJF;IAKI,gBAAA;EAvEF;AACF;AAyEE;EARF;IASI,gBAAA;EAtEF;AACF;AAwEE;EAZF;IAaI,gBAAA;EArEF;AACF;;AAwEA;EACE,gBAAA;AArEF;AAuEE;EAHF;IAII,gBAAA;EApEF;AACF;AAsEE;EAPF;IAQI,gBAAA;EAnEF;AACF;AAqEE;EAXF;IAYI,gBAAA;EAlEF;AACF;;AAqEA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EA5HA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAyHA,qBAAA;EACA,aAAA;AA7DF;AA+DE;EARF;IASI,gBAAA;EA5DF;AACF;AA8DE;EAZF;IAaI,aAAA;EA3DF;AACF;;AA8DA;EACE,gBAAA;EACA,WAAA;EA5IA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAyIA,qBAAA;EACA,aAAA;AAtDF;AAwDE;EAPF;IAQI,gBAAA;EArDF;AACF;AAuDE;EAXF;IAYI,gBAAA;EApDF;AACF;AAsDE;EAfF;IAgBI,gBAAA;EAnDF;AACF;;AAsDA;EACE,gBAAA;AAnDF;AAqDE;EAHF;IAII,gBAAA;EAlDF;AACF;AAoDE;EAPF;IAQI,gBAAA;EAjDF;AACF;AAmDE;EAXF;IAYI,gBAAA;EAhDF;AACF;AAmDI;EADF;IAEI,gBAAA;EAhDJ;AACF;AAkDI;EALF;IAMI,gBAAA;EA/CJ;AACF;;AAoDE;EADF;IAEI,gBAAA;IA1LF,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qBAAA;IACA,oBAAA;IACA,4BAAA;IAuLE,qBAAA;IACA,aAAA;EA3CF;AACF;AA6CE;EARF;IASI,gBAAA;EA1CF;AACF;AAgDA;EACE,gBAAA;EACA,WAAA;EA1MA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAuMA,qBAAA;EACA,aAAA;AAzCF;AA2CE;EAPF;IAQI,gBAAA;EAxCF;AACF;AA0CE;EAXF;IAYI,gBAAA;EAvCF;AACF;AAyCE;EAfF;IAgBI,aAAA;EAtCF;AACF;;AAyCA;EACE,gBAAA;AAtCF;AAwCE;EAHF;IAII,gBAAA;EArCF;AACF;AAuCE;EAPF;IAQI,gBAAA;EApCF;AACF;;AAuCA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AApCF;AAsCE;EALF;IAMI,gBAAA;EAnCF;AACF;AAqCE;EATF;IAUI,gBAAA;EAlCF;AACF;AAoCE;EAbF;IAcI,gBAAA;IACA,YAAA;EAjCF;AACF;;AAoCA;EACE,WAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,yDAAA;EACA,qDAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,0CAAA;EACA,SAAA;AAjCF;AAmCE;EAVF;IAWI,8BAAA;EAhCF;AACF;AAkCE;EAdF;IAeI,cAAA;EA/BF;AACF;;AAkCA;EACE,gBAAA;EA7RA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AA+PF;;AA8BA;EACE,wDAAA;AA3BF;;AA8BA;EACE,oDAAA;AA3BF;;AA8BA;EACE,wDAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,WAAA;EAxTA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAqTA,qBAAA;EACA,aAAA;AAtBF;AAwBE;EAPF;IAQI,gBAAA;IACA,iBAAA;EArBF;AACF;AAuBE;EAZF;IAaI,gBAAA;EApBF;AACF;AAsBE;EAhBF;IAiBI,eAAA;IACA,eAAA;EAnBF;AACF;;AAsBA;EACE,gBAAA;AAnBF;AAqBE;EAHF;IAII,gBAAA;EAlBF;AACF;AAoBE;EAPF;IAQI,mBAAA;EAjBF;AACF;AAmBE;EAXF;IAYI,eAAA;EAhBF;AACF;;AAmBA;EA5VE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAyVA,qBAAA;EACA,aAAA;AAXF;AAaE;EALF;IAMI,gBAAA;EAVF;AACF;;AAaA;EACE,cAAA;EACA,gBAAA;EACA,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAVF;AAYE;EAVF;IAWI,eAAA;EATF;AACF;;AAYA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AATF;AAWE;EALF;IAMI,gBAAA;EARF;AACF;AAUE;EATF;IAUI,gBAAA;IACA,eAAA;EAPF;AACF;;AAUA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPF;AASE;EARF;IASI,eAAA;EANF;AACF;;AASA;EACE,iBAAA;EACA,SAAA;AANF;AAQE;EACE,YAAA;AANJ;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,eAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,aAAA;AARF;AAUE;EAHF;IAII,cAAA;IACA,gBAAA;IA/aF,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qBAAA;IACA,oBAAA;IACA,4BAAA;IA4aE,aAAA;EAFF;AACF;;AAKA;EArbE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAkbA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AAGF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tableBody {\n  font-size: 14px;\n  line-height: 14px;\n\n  @media (max-width: 1080px) {\n    font-size: 12px;\n  }\n}\n\n.tableBodyRowWrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  scroll-margin-top: 105px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n  padding: 0 25px 0 35px;\n  font-style: normal;\n  font-weight: 400;\n\n  @media (max-width: 1080px) {\n    padding: 0;\n  }\n\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.onboardingTable {\n  max-height: 370px;\n  height: 100%;\n  overflow: hidden;\n  margin-bottom: 5px;\n}\n\n.tableBodyRowCategory {\n  width: 100%;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  display: flex;\n  height: 45px;\n  padding: 0px 15px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.expandArrow {\n  transform: rotate(-90deg);\n}\n\n.tableBodyRowRecentlyViewed {\n  background: var(--tables-primary-row-surface-hover);\n}\n\n.tableBodyRowType {\n  max-width: 410px;\n  width: 100%;\n\n  @media (max-width: 1536px) {\n    max-width: 265px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 170px;\n  }\n\n  @media (max-width: 1080px) {\n    max-width: 130px;\n  }\n}\n\n.tableBodyRowTypeWithoutWo {\n  max-width: 425px;\n\n  @media (max-width: 1536px) {\n    max-width: 345px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 240px;\n  }\n\n  @media (max-width: 850px) {\n    max-width: 100px;\n  }\n}\n\n.tableBodyRowWo {\n  max-width: 115px;\n  width: 100%;\n  margin-right: 15px;\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 1280px) {\n    max-width: 105px;\n  }\n\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n\n.tableBodyRowEquipment {\n  max-width: 410px;\n  width: 100%;\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 1536px) {\n    max-width: 265px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 170px;\n  }\n\n  @media (max-width: 1080px) {\n    max-width: 130px;\n  }\n}\n\n.tableBodyRowEquipmentWithoutWo {\n  max-width: 425px;\n\n  @media (max-width: 1536px) {\n    max-width: 345px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 240px;\n  }\n\n  @media (max-width: 850px) {\n    max-width: 100px;\n  }\n\n  .tableBodyRowEquipmentSmall {\n    @media (max-width: 1536px) {\n      max-width: 285px;\n    }\n\n    @media (max-width: 1440px) {\n      max-width: 240px;\n    }\n  }\n}\n\n.tableBodyRowEquipmentSmall {\n  @media (max-width: 1536px) {\n    max-width: 230px;\n    @include ellipsis-text;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n  }\n\n  @media (max-width: 1140px) {\n    max-width: 150px;\n  }\n\n  @media (max-width: 850px) {\n  }\n}\n\n.tableBodyRowComponent {\n  max-width: 250px;\n  width: 100%;\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 1536px) {\n    max-width: 200px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 150px;\n  }\n\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n\n.tableBodyRowComponentWithoutWo {\n  max-width: 265px;\n\n  @media (max-width: 1536px) {\n    max-width: 215px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 165px;\n  }\n}\n\n.tableBodyRowUpdate {\n  max-width: 450px;\n  width: 100%;\n  text-align: end;\n\n  @media (max-width: 1440px) {\n    max-width: 280px;\n  }\n\n  @media (max-width: 1080px) {\n    max-width: 125px;\n  }\n\n  @media (max-width: 850px) {\n    max-width: unset;\n    width: 180px;\n  }\n}\n\n.tableBodyRowEmpty {\n  width: 100%;\n}\n\n.tableBodyRowCategory {\n  width: 100%;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  display: flex;\n  height: 45px;\n  padding: 0px 15px;\n  align-items: center;\n  gap: 5px;\n  align-self: stretch;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.tableBodyRow {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px 5px;\n  width: 100%;\n  color: var(--tables-primary-row-text-main);\n  gap: 10px;\n\n  @media (min-width: 1921px) {\n    justify-content: space-between;\n  }\n\n  @media (max-width: 850px) {\n    margin-left: 0;\n  }\n}\n\n.aiTableTooltip {\n  max-width: 300px;\n  @include tooltip;\n}\n\n.urgencyStandard {\n  border-left: 3px solid var(--legend-for-header-standard);\n}\n\n.urgencyHigh {\n  border-left: 3px solid var(--legend-for-header-high);\n}\n\n.urgencyCritical {\n  border-left: 3px solid var(--legend-for-header-critical);\n}\n\n.tableBodyRowLocation {\n  max-width: 250px;\n  width: 100%;\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 1536px) {\n    max-width: 150px;\n    margin-right: 7px;\n  }\n\n  @media (max-width: 1280px) {\n    max-width: 135px;\n  }\n\n  @media (max-width: 1080px) {\n    max-width: 70px;\n    margin-right: 0;\n  }\n}\n\n.tableBodyRowLocationWithoutWo {\n  max-width: 275px;\n\n  @media (max-width: 1536px) {\n    max-width: 160px;\n  }\n\n  @media (max-width: 1280px) {\n    padding-right: 15px;\n  }\n\n  @media (max-width: 850px) {\n    max-width: 95px;\n  }\n}\n\n.tableBodyRowLocationName {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 1080px) {\n    overflow: hidden;\n  }\n}\n\n.tableRowAdditionalInfo {\n  display: block;\n  max-width: 130px;\n  color: var(--tables-primary-row-text-additional);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  margin-top: 2px;\n\n  @media (max-width: 1080px) {\n    font-size: 12px;\n  }\n}\n\n.tableBodyRowTime {\n  max-width: 130px;\n  width: 100%;\n  text-align: end;\n\n  @media (max-width: 1280px) {\n    max-width: 140px;\n  }\n\n  @media (max-width: 850px) {\n    max-width: 115px;\n    text-align: end;\n  }\n}\n\n.tableRowUpdatedInfo {\n  color: var(--tables-primary-row-text-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  margin-bottom: 2px;\n\n  @media (max-width: 1080px) {\n    font-size: 12px;\n  }\n}\n\n.tableBodyRowSkeleton {\n  padding: 16.5px 0;\n  gap: 25px;\n\n  & > div {\n    height: 24px;\n  }\n}\n\n.skeletonTextClassName {\n  height: 24px;\n}\n\n.skeletonTableBodyRowWrapper {\n  cursor: default;\n\n  &:hover {\n    background: initial;\n  }\n}\n\n.tableBodyRowBold {\n  font-weight: bolder;\n}\n\n.tableCellsHide {\n  display: none;\n\n  @media (max-width: 850px) {\n    display: block;\n    max-width: 126px;\n    @include ellipsis-text;\n    line-clamp: 2;\n  }\n}\n\n.tableCellTitle {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  max-width: unset;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBody": `tableBody__JxQKT`,
	"tableBodyRowWrapper": `tableBodyRowWrapper__cI7i_`,
	"onboardingTable": `onboardingTable__tdYYq`,
	"tableBodyRowCategory": `tableBodyRowCategory__jG27Y`,
	"expandArrow": `expandArrow__YKhQI`,
	"tableBodyRowRecentlyViewed": `tableBodyRowRecentlyViewed__BPvZ5`,
	"tableBodyRowType": `tableBodyRowType__hrkwN`,
	"tableBodyRowTypeWithoutWo": `tableBodyRowTypeWithoutWo__HFTTv`,
	"tableBodyRowWo": `tableBodyRowWo__Xy4I8`,
	"tableBodyRowEquipment": `tableBodyRowEquipment__SDPTo`,
	"tableBodyRowEquipmentWithoutWo": `tableBodyRowEquipmentWithoutWo__QTq6x`,
	"tableBodyRowEquipmentSmall": `tableBodyRowEquipmentSmall__LkaPs`,
	"tableBodyRowComponent": `tableBodyRowComponent__lf6zb`,
	"tableBodyRowComponentWithoutWo": `tableBodyRowComponentWithoutWo__WyCT8`,
	"tableBodyRowUpdate": `tableBodyRowUpdate__mHivR`,
	"tableBodyRowEmpty": `tableBodyRowEmpty__MqL5N`,
	"tableBodyRow": `tableBodyRow__hFlrx`,
	"aiTableTooltip": `aiTableTooltip__zNeUt`,
	"urgencyStandard": `urgencyStandard__DtClR`,
	"urgencyHigh": `urgencyHigh__qsf7O`,
	"urgencyCritical": `urgencyCritical__OZa97`,
	"tableBodyRowLocation": `tableBodyRowLocation__nm2Ax`,
	"tableBodyRowLocationWithoutWo": `tableBodyRowLocationWithoutWo__tzWlE`,
	"tableBodyRowLocationName": `tableBodyRowLocationName__es2i4`,
	"tableRowAdditionalInfo": `tableRowAdditionalInfo__FYtza`,
	"tableBodyRowTime": `tableBodyRowTime__TO2rW`,
	"tableRowUpdatedInfo": `tableRowUpdatedInfo__rwq8E`,
	"tableBodyRowSkeleton": `tableBodyRowSkeleton__E0IKv`,
	"skeletonTextClassName": `skeletonTextClassName__DYNYP`,
	"skeletonTableBodyRowWrapper": `skeletonTableBodyRowWrapper__qReyJ`,
	"tableBodyRowBold": `tableBodyRowBold__ycWar`,
	"tableCellsHide": `tableCellsHide__JqBEo`,
	"tableCellTitle": `tableCellTitle__d1H_i`
};
module.exports = ___CSS_LOADER_EXPORT___;
